import React from 'react';
import VitaminsReports from 'components/business/VitaminsReports';

export const ReportsCtx = React.createContext({});

function VitaminsPageProvider(props) {
  const ctx = {
  };
  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function VitaminsPage() {
  return (
    <VitaminsPageProvider>
      <VitaminsReports />
    </VitaminsPageProvider>
  );
}

export default VitaminsPage;
